import * as React from "react";
import { Modal,Table} from "antd";
import { connect } from "react-redux";

interface IPaymentlistProps {
  id:any;
  paymentlist:any;
}

// 修改
class Paymentlist extends React.Component<IPaymentlistProps, any> {
  state = {
    paymentlist:[],
    visible:false,
  };
  constructor(props: IPaymentlistProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  paymentlist(id) {
    this.setState({
      visible:true
    })
    const param: any = {
      id: id
    }; 
    this.props.paymentlist({
      ...param,
      callback: (data) => {
        this.setState({
           paymentlist: data
        });
      }
     });
   }

  render() {
    const dataSource = this.state.paymentlist;
    
    const columns = [{
      title: '',
      dataIndex: 'type',
      key: 'type',
    },{
      title: '订单编号',
      dataIndex: 'number',
      key: 'number',
    }, {
      title: '销售单价*数量',
      dataIndex: 'adult_price',
      key:'adult_price',
      render: (text, row, index) => {
        return (
          <React.Fragment>
             <p>数量  {row.price}*{row.num} </p>
             <p>成人  {row.adult_price}*{row.adult_num} </p>
             <p>儿童  {row.child_price}*{row.children_num} </p>
          </React.Fragment>
        );
      }
    }, {
      title: '总销售金额',
      dataIndex: 'sale_amount',
      key: 'sale_amount',
    }, {
      title: '交通附加费',
      dataIndex: 'surcharge_amount',
      key: 'surcharge_amount',
    }, {
      title: '优惠券抵扣金额',
      dataIndex: 'discount_fee',
      key: 'discount_fee',
    }, {
      title: '商业折扣',
      dataIndex: 'part_mjz_discount',
      key: 'part_mjz_discounts',
    }, {
      title: '积分抵扣金额',
      dataIndex: 'point_fee',
      key: 'point_fee',
    }, {
      title: '实付金额',
      dataIndex: 'payment',
      key: 'payment',
    }];
    return (
      <React.Fragment>
      <a onClick={this.paymentlist.bind(this,this.props.id)}>查看</a>
      <Modal maskClosable={false} onCancel={this.handleCancel} title="查看付款信息" visible={this.state.visible} footer={null} width="auto" centered={true}>
      <Table bordered={true} pagination={false} dataSource={dataSource} columns={columns} />
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    paymentlist: dispatch.orderDetails.paymentlist
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Paymentlist);
